/*
 * @Author: Moustach_壮壮
 * @Date: 2024-04-07 22:27:24
 * @LastEditTime: 2024-04-22 22:44:54
 * @Description: file context
 */
import { createApp } from 'vue';
import App from './App.vue';
import { createRouter, createWebHashHistory } from 'vue-router';
// 2. 引入组件样式
import 'vant/lib/index.css';
import { Notify, CountDown, Uploader } from 'vant';
const routes = [
  {
    path: '/dailyWelfare',
    name: 'dailyWelfare',
    component: () => import('./views/DailyWelfare.vue'),
  },
  {
    path: '/drawMoney',
    name: 'drawMoney',
    component: () => import('./views/DrawMoney.vue'),
  },
  {
    path: '/personCenter',
    name: 'personCenter',
    component: () => import('./views/PersonCenter.vue'),
  },
  {
    path: '/',
    name: 'downLoad',
    component: () => import('./views/DownLoad.vue'),
  },
  {
    path: '/invite',
    name: 'invite',
    component: () => import('./views/InviteFriend.vue'),
  },
  {
    path: '/inviteMoney',
    name: 'inviteMoney',
    component: () => import('./views/InviteMoney.vue'),
  },
  {
    path: '/drawList',
    name: 'drawList',
    component: () => import('./views/DrawList.vue'),
  },
  {
    path: '/yuanbao',
    name: 'yuanbao',
    component: () => import('./views/YuanbaoList.vue'),
  },
];
// 创建路由实例
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

const app = createApp(App);

app.use(router);
app.use(Notify);
app.use(CountDown);
app.use(Uploader);
app.mount('#app');
